import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=d27a4fe4&scoped=true&"
import script from "./Publication.js?vue&type=script&lang=js&"
export * from "./Publication.js?vue&type=script&lang=js&"
import style0 from "./Publication.scss?vue&type=style&index=0&id=d27a4fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a4fe4",
  null
  
)

export default component.exports